<!-- Mise à jour pour améliorer la visibilité et la séparation des sections -->

<div class="intervention-container">
  <div class="intervention-content">
    <!-- Loader avec le même style que les autres composants -->
    <div *ngIf="!formInitialized" class="loader-container">
      <p-progressSpinner
        [style]="{ width: '50px', height: '50px' }"
      ></p-progressSpinner>
    </div>

    <form
      [formGroup]="form"
      *ngIf="form && formInitialized"
      class="form-wrapper"
    >
      <!-- Conteneur pour ajouter plus d'espace entre les blocs -->
      <div class="section-container">
        <!-- Section Informations - Utiliser p-card pour être cohérent avec les autres étapes -->
        <p-card styleClass="mb-4" class="card-custom form-section">
          <ng-template pTemplate="header">
            <div class="p-1 bg-neutral-900 flex items-center">
              <i class="pi pi-info-circle mr-2"></i>
              <h3 class="text-base m-0">Informations</h3>
            </div>
          </ng-template>
          <div class="p-3">
            <div class="flex flex-col gap-3">
              <div class="form-item">
                <label class="block mb-2 text-sm">Nom</label>
                <div class="relative">
                  <input
                    type="text"
                    pInputText
                    formControlName="name"
                    class="w-full"
                    [disabled]="isLoadingName"
                  />
                  <div
                    *ngIf="isLoadingName"
                    class="absolute top-0 right-0 flex items-center h-full pr-2"
                  >
                    <p-progressSpinner
                      [style]="{ width: '20px', height: '20px' }"
                      styleClass="custom-spinner"
                    ></p-progressSpinner>
                  </div>
                </div>
              </div>

              <div class="form-item">
                <label class="block mb-2 text-sm">Description générée</label>
                <div class="textarea-container relative">
                  <textarea
                    rows="6"
                    pInputTextarea
                    formControlName="generatedDescription"
                    [disabled]="true || isLoadingDescription"
                    placeholder="Description générée automatiquement"
                    class="w-full mb-2 dark-textarea"
                  ></textarea>
                  <div
                    *ngIf="isLoadingDescription"
                    class="absolute top-2 right-2 flex items-center"
                  >
                    <p-progressSpinner
                      [style]="{ width: '20px', height: '20px' }"
                      styleClass="custom-spinner"
                    ></p-progressSpinner>
                  </div>
                </div>

                <label class="block mb-2 mt-3 text-sm"
                  >Commentaires additionnels</label
                >
                <div class="textarea-container">
                  <textarea
                    rows="4"
                    pInputTextarea
                    formControlName="description"
                    placeholder="Ajoutez des commentaires supplémentaires ici"
                    class="w-full dark-textarea"
                  ></textarea>
                </div>
              </div>

              <div class="grid grid-cols-1 md:grid-cols-2 gap-2 mt-3">
                <div class="flex items-center">
                  <p-checkbox
                    formControlName="isDeliveredHouse"
                    [binary]="true"
                    styleClass="mr-2"
                  ></p-checkbox>
                  <label class="text-sm cursor-pointer">Maison livrée</label>
                </div>

                <div class="flex items-center">
                  <p-checkbox
                    formControlName="isWaitingCheck"
                    [binary]="true"
                    styleClass="mr-2"
                  ></p-checkbox>
                  <label class="text-sm cursor-pointer"
                    >En attente règlement</label
                  >
                </div>

                <div class="flex items-center">
                  <p-checkbox
                    formControlName="isOffice"
                    [binary]="true"
                    styleClass="mr-2"
                  ></p-checkbox>
                  <label class="text-sm cursor-pointer">Au bureau</label>
                </div>

                <div class="flex items-center">
                  <p-checkbox
                    formControlName="recoverCheck"
                    [binary]="true"
                    styleClass="mr-2"
                  ></p-checkbox>
                  <label class="text-sm cursor-pointer"
                    >Récupérer le chèque</label
                  >
                </div>

                <div class="flex items-center">
                  <p-checkbox
                    formControlName="doNotShift"
                    [binary]="true"
                    styleClass="mr-2"
                  ></p-checkbox>
                  <label class="text-sm cursor-pointer mr-3"
                    >Ne pas décaler</label
                  >
                  <input
                    *ngIf="form.get('doNotShift')?.value"
                    type="text"
                    pInputText
                    formControlName="doNotShiftReason"
                    placeholder="Raison"
                    class="flex-1"
                  />
                </div>
              </div>
            </div>
          </div>
        </p-card>

        <!-- Nouvelle section: Contact sur place -->
        <p-card styleClass="mb-4" class="card-custom form-section">
          <ng-template pTemplate="header">
            <div class="p-1 bg-neutral-900 flex items-center">
              <i class="pi pi-user mr-2"></i>
              <h3 class="text-base m-0">Contact sur place</h3>
            </div>
          </ng-template>
          <div class="p-3">
            <div class="flex flex-col gap-3">
              <div class="form-item">
                <label class="block mb-2 text-sm"
                  >Conducteur de travaux / Contact sur place</label
                >
                <p-select
                  formControlName="worksSupervisorId"
                  [options]="contacts"
                  optionLabel="firstname"
                  optionValue="id"
                  placeholder="Sélectionner des contacts"
                  display="chip"
                  [showClear]="true"
                  styleClass="w-full"
                  [appendTo]="'body'"
                  [filter]="true"
                  filterBy="firstname,lastname"
                  filterPlaceholder="Rechercher un contact..."
                >
                  <ng-template let-contact pTemplate="selectedItem">
                    <span class="text-sm">
                      {{ contact.firstname }} {{ contact.lastname }}
                    </span>
                  </ng-template>
                  <ng-template let-contact pTemplate="item">
                    <div class="flex items-center p-1">
                      <span class="text-sm">
                        {{ contact.firstname }} {{ contact.lastname }}
                      </span>
                    </div>
                  </ng-template>
                </p-select>
              </div>
              <div class="form-item">
                <label class="block mb-2 text-sm">Contacts</label>
                <p-multiSelect
                  formControlName="contacts"
                  [options]="contacts"
                  optionLabel="firstname"
                  optionValue="id"
                  placeholder="Sélectionner des contacts"
                  display="chip"
                  [showClear]="true"
                  styleClass="w-full"
                  [appendTo]="'body'"
                  [filter]="true"
                  filterBy="firstname,lastname"
                  filterPlaceholder="Rechercher un contact..."
                >
                  <ng-template let-contact pTemplate="selectedItems">
                    <ng-container
                      *ngIf="
                        contact && contact.length > 0;
                        else placeholderContacts
                      "
                    >
                      <span *ngFor="let c of contact" class="text-sm mr-1">
                        {{ c.firstname }} {{ c.lastname }},
                      </span>
                    </ng-container>
                    <ng-template #placeholderContacts>
                      <span class="text-gray-400"
                        >Sélectionner des contacts</span
                      >
                    </ng-template>
                  </ng-template>
                  <ng-template let-contact pTemplate="item">
                    <div class="flex items-center p-1">
                      <span class="text-sm">
                        {{ contact.firstname }} {{ contact.lastname }}
                      </span>
                    </div>
                  </ng-template>
                </p-multiSelect>
              </div>

              <div class="form-item">
                <label class="block mb-2 text-sm">Contacts d'affaire</label>
                <p-multiSelect
                  formControlName="affairsContacts"
                  [options]="affairsContacts"
                  optionLabel="firstname"
                  optionValue="id"
                  placeholder="Sélectionner des contacts d'affaire"
                  display="chip"
                  [showClear]="true"
                  styleClass="w-full"
                  [appendTo]="'body'"
                >
                  <ng-template let-affairContact pTemplate="item">
                    <div class="flex items-center p-1">
                      <span class="text-sm">
                        {{ affairContact.firstname }}
                        {{ affairContact.lastname }}
                      </span>
                    </div>
                  </ng-template>
                </p-multiSelect>
              </div>
            </div>
          </div>
          <div
            *ngIf="
              affair.srcErp.abm?.administrativeInternalNote ||
              affair.srcErp.nrj?.administrativeInternalNote
            "
          >
            <label class="block mb-2 mt-3 text-sm">Notes</label>
            <div
              class="textarea-container bg-[#1e1e1ee6] p-2"
              style="line-break: anywhere"
              [innerHTML]="
                affair.srcErp.abm?.administrativeInternalNote ===
                affair.srcErp.nrj?.administrativeInternalNote
                  ? affair.srcErp.abm?.administrativeInternalNote
                  : 'ABM: ' +
                    affair.srcErp.abm?.administrativeInternalNote +
                    ' NRJ: ' +
                    affair.srcErp.nrj?.administrativeInternalNote
              "
            ></div>
          </div>
        </p-card>
      </div>
    </form>
  </div>
</div>
